import React from 'react'
import { motion } from 'framer-motion'
import SafeIcon from '../../common/SafeIcon'

const StatsCard = ({ title, value, icon, color, format }) => {
  const formatValue = (val, fmt) => {
    switch (fmt) {
      case 'currency':
        return `Rp ${Math.abs(val).toLocaleString('id-ID')}`
      case 'percentage':
        return `${val.toFixed(1)}%`
      case 'decimal':
        return val.toFixed(2)
      default:
        return val.toString()
    }
  }

  const getColorClasses = (color) => {
    const colorMap = {
      blue: 'text-blue-600 bg-blue-100',
      green: 'text-green-600 bg-green-100',
      red: 'text-red-600 bg-red-100',
      purple: 'text-purple-600 bg-purple-100'
    }
    return colorMap[color] || colorMap.blue
  }

  return (
    <motion.div 
      whileHover={{ y: -5 }}
      className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow"
    >
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium text-gray-600">{title}</p>
          <p className={`text-2xl font-bold mt-1 ${title.includes('P&L') ? (value >= 0 ? 'text-green-600' : 'text-red-600') : 'text-gray-900'}`}>
            {value < 0 && format === 'currency' ? '-' : ''}
            {formatValue(value, format)}
          </p>
        </div>
        <div className={`p-3 rounded-lg ${getColorClasses(color)}`}>
          <SafeIcon icon={icon} className="h-6 w-6" />
        </div>
      </div>
    </motion.div>
  )
}

export default StatsCard